import { Controller } from "@hotwired/stimulus";
import SignageScreenDisplayController from "./signage_screen_controller";
import SignageSlideHeaderController from "./signage_slide_header_controller";

export default class extends Controller {
  static targets = ["slideHeader", "screen"];
  connect(): void {}
  // 再生 → screen に伝える
  onPlay() {
    const controller = this.getControllerFromTarget<SignageScreenDisplayController>("screenDisplay", "signage-screen");

    controller?.play();
  }

  // 停止 → screen に伝える
  onPause() {
    const controller = this.getControllerFromTarget<SignageScreenDisplayController>("screenDisplay", "signage-screen");

    controller?.pause();
  }

  //  スライド変更通知 → slide-header に伝える
  onSlideChanged(event: CustomEvent) {
    const controller = this.getControllerFromTarget<SignageSlideHeaderController>("slideHeader", "signage-slide-header");

    controller?.slideChanged(event);
  }

  private getControllerFromTarget<T>(targetName: string, identifier: string): T | null {
    const el = this.targets.find(targetName) as HTMLElement;
    const controller = this.application.getControllerForElementAndIdentifier(el, identifier);

    return controller as T;
  }
}
